/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component } from '@angular/core';

@Component({
  selector: 'ods-form-footer',
  host: { class: 'flex flex-1 flex-col gap-4' },
  template: `
    <div role="alert" class="empty:hidden" data-test-id="form-footer-errors">
      <ng-content select="[errors]" />
    </div>
    <div class="flex flex-row flex-wrap gap-4" data-test-id="form-footer-buttons">
      <div class="flex flex-1 flex-row flex-wrap gap-4">
        <ng-content select="[left]" />
      </div>
      <div class="flex flex-row flex-wrap gap-4">
        <ng-content select="[right]" />
      </div>
    </div>
  `,
})
export class FormFooterComponent {}
